var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSidebarLeft = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.75,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 18,
  x: 3,
  y: 3,
  rx: 2
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "     M11,3     v18     h-5.5     q-2.5,0 -2.5,-2.5     v-13     q0,-2.5 2.5,-2.5     h2.5"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.5,8 h3",
  strokeWidth: 1.75
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M5.5,12 h3",
  strokeWidth: 1.75
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M5.5,16 h3",
  strokeWidth: 1.75
})));
export default SvgSidebarLeft;